module.exports = __webpack_public_path__ + "static/media/map_pin.221bcd47.svg";